var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "817px",
    height: "1286px",
    viewBox: "0 0 817 1286",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "vecteezy_padlock-icon-lock-and-unlock-icon-vector-design_",
    transform: "translate(-2023.000000, -357.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2467.39,1248.53 L2467.39,1388.13 C2467.39,1401.93 2456.28,1413.03 2442.59,1413.03 L2419.68,1413.03 C2405.98,1413.03 2394.78,1401.93 2394.78,1388.13 L2394.78,1248.53 C2373.28,1234.33 2360.68,1207.83 2366.78,1179.03 C2372.08,1154.33 2392.08,1134.43 2416.88,1129.23 C2459.48,1120.33 2496.98,1152.53 2496.98,1193.63 C2496.98,1216.53 2485.19,1236.73 2467.39,1248.53 Z M2710.28,898.129 L2244.68,898.129 L2244.68,642.18 C2244.68,539.378 2328.32,455.739 2431.12,455.739 C2533.93,455.739 2617.56,539.378 2617.56,642.18 L2617.56,767.433 L2715.88,767.433 L2715.88,642.18 C2715.88,485.167 2588.14,357.433 2431.12,357.433 C2274.11,357.433 2146.37,485.167 2146.37,642.18 L2146.37,898.17 L2151.19,898.17 C2080.46,898.604 2023.18,956.099 2023.18,1026.93 L2023.18,1513.83 C2023.18,1584.93 2080.88,1642.53 2151.98,1642.53 L2710.28,1642.53 C2781.38,1642.53 2839.08,1584.93 2839.08,1513.83 L2839.08,1026.93 C2839.08,955.83 2781.38,898.129 2710.28,898.129 L2710.28,898.129 Z",
    id: "Fill-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.d5b416e1625cb66fd28e1055e346e597.svg";
export { ForwardRef as ReactComponent };